import { Expose, Type } from "class-transformer"
import { ApplicationEntity } from "../application-entity"
import ActivityHistory from "./activity-history"

class ActivityHistoryLog extends ApplicationEntity {

  @Expose()
  public id: number | null = null

  @Expose()
  @Type(() => ActivityHistory)
  public activityHistory: ActivityHistory | null = null


  public static exportUrl: string | null = null

}

export default ActivityHistoryLog
